import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  POTEKA_TYPE_AIR_TEMP,
  POTEKA_TYPE_PRECIPITATION,
  POTEKA_TYPE_RELATIVE_HUMIDITY,
  POTEKA_TYPE_WEATHER,
  POTEKA_TYPE_WIND_DIR
} from "../layers/Poteka";
import {
  LegendBoxContentsName,
  LegendBoxList,
  LegendCssCircleIcoListItem,
  LegendCssSquareIconListItem,
  LegendListDivider
} from "../../legend/LegendBoxComponents";
import { useRecoilValue } from "recoil";
import { potekaElementState } from "../../../store/PotekaElementState";
import { memo } from "react";

function LegendPoteka() {
  const dataType = useRecoilValue(potekaElementState);

  const getLegendComponent = (dataType) => {
    switch (dataType) {
      case POTEKA_TYPE_AIR_TEMP:
        return <Temperature dataType={dataType}/>;
      case POTEKA_TYPE_PRECIPITATION:
        return <Precipitation dataType={dataType}/>;
      case POTEKA_TYPE_WEATHER:
        return <Weather dataType={dataType}/>;
      case POTEKA_TYPE_RELATIVE_HUMIDITY:
        return <RelativeHumidity dataType={dataType}/>;
      default:
        return null;
    }
  }

  return (
    <Box sx={{display:'flex', columnGap:10, minWidth: 107}}>
      {
        getLegendComponent(dataType)
      }
      <Wind/>
    </Box>
  );
}

function LegendBoxPotekaName(props) {
  const { dataType } = props;
  let name = "";
  let unit = ""
  const {t} = useTranslation();
  switch(dataType) {
    case POTEKA_TYPE_PRECIPITATION:
      name = "Precipitation";
      unit = "(mm/h)";
      break;
    case POTEKA_TYPE_AIR_TEMP:
      name = "Temperature";
      unit = "(°C)";
      break;
    case POTEKA_TYPE_WEATHER:
      name = "Weather";
      unit = "";
      break;
    case POTEKA_TYPE_RELATIVE_HUMIDITY:
      name = "Relative humidity";
      unit = "(%)";
      break;
    case POTEKA_TYPE_WIND_DIR:
      name = "Wind speed";
      unit = "(kt)";
      break;
    default:
      break;
  }
  return (
    <Box>
      <LegendBoxContentsName>{t(name)} {unit}</LegendBoxContentsName>
    </Box>
  )
}

function Weather(props) {
  const { dataType } = props;
  const {t} = useTranslation();
  return (
    <div>
      <LegendBoxPotekaName {...props}/>
      <Box sx={{display: dataType !== POTEKA_TYPE_WEATHER ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssCircleIcoListItem background={'rgb(255 ,0 ,0)'}     text={<>{t('Sunny')}</>}></LegendCssCircleIcoListItem>
          <LegendCssCircleIcoListItem background={'rgb(128, 128, 128)'} text={<>{t('Cloudy')}</>}></LegendCssCircleIcoListItem>
          <LegendCssCircleIcoListItem background={'rgb(0, 0, 255)'}     text={<>{t('Rain')}</>}></LegendCssCircleIcoListItem>
          <LegendCssCircleIcoListItem background={'rgb(0, 0, 0)'}       text={<>{t('Night')}</>}></LegendCssCircleIcoListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Temperature(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxPotekaName {...props}/>
      <Box sx={{display: dataType !== POTEKA_TYPE_AIR_TEMP ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>35</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>30</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>25</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 150)'} text={<>15</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 240)'} text={<>10</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(185, 235, 255)'} text={<>5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 150, 255)'} text={<>0</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<>-5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 32, 128)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Precipitation(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxPotekaName {...props}/>
      <Box sx={{display: dataType !== POTEKA_TYPE_PRECIPITATION ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>80</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>50</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>30</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<>10</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(33, 140, 255)'} text={<>5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(160, 210, 255)'} text={<>1</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(242, 242, 255)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function RelativeHumidity(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxPotekaName {...props}/>
      <Box sx={{display: dataType !== POTEKA_TYPE_RELATIVE_HUMIDITY ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(255, 0, 0)'} text={<>80</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 127, 0)'} text={<>60</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 0)'} text={<>40</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 255, 0)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 255)'} text={<>0</>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Wind() {
  return (
    <div>
      <LegendBoxPotekaName dataType={POTEKA_TYPE_WIND_DIR}/>
      <Box sx={{display:  "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(251, 0, 6)'} text={<>48</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(253, 135, 9)'} text={<>38</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 11)'} text={<>28</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(34, 255, 8)'} text={<>18</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 255)'} text={<>8</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 0)'} text={<>0</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
        </LegendBoxList>
      </Box>
    </div>
  )
}

export default memo(LegendPoteka);